import { SxProps, Theme } from '@mui/material';

export const buttonSX: SxProps<Theme> = {
	borderRadius: '25px',
	paddingTop: '8px',
	paddingBottom: '8px',
	paddingLeft: '21.5px',
	paddingRight: '21.5px',
	backgroundColor: '#F1F1F1',
	color: '#1565C0',
	fontSize: { xs: 'var(--font-size-sm)', sm: 'var(--font-size-md)' },
	fontWeight: 'bold',
	'&:hover': {
		backgroundColor: '#e1e1e1',
	},
};

export const buttonLinkSX: SxProps<Theme> = {
	borderRadius: '25px',
	paddingTop: '0px',
	paddingBottom: '0px',
	// paddingLeft: '38px',
	// paddingRight: '38px',
	backgroundColor: 'transparent',
	color: '#1565C0',
	fontSize: 'var(--font-size-md)',
	fontWeight: 'bold',
	// mx: '6px',
	'&:hover': {
		backgroundColor: '#e1e1e1',
	},
};
